/**
 * Konfigurácia logout glue.
 *
 * Median/GoNative appky a starý B2B wrapper sú stále v storoch (kým si ich
 * používatelia neupdatujú) a majú vlastný logout skript nad tým istým cookie
 * (`common/flutter-logout.js`). Bez `keepCookieOutsideApp` by mu kanonický
 * modul cookie mimo našej appky zmazal skôr, než ho stihne prečítať — starým
 * appkám by logout wipe tichо prestal fungovať.
 *
 * Druhá polovica tohto páru je guard v `common/flutter-logout.js`, ktorý sa
 * naopak nespustí v našej appke. Takto má cookie v každom prostredí presne
 * jedného vlastníka. Po vyradení starých appiek z obehu sa dá zmazať oboje.
 *
 * Vlastný modul, nie riadok v index.js: ESM importy sa hoistujú, takže
 * priradenie zapísané medzi importami by prebehlo AŽ PO evale glue modulu.
 */
window.__appLogoutConfig = {
    keepCookieOutsideApp: true,
};
